export const scope = 'boilerplate.components.Widgets';

const messages:any = {
    schooling_dashbord: `${scope}.KpIndicatorWidget.dashboard.schooling_dashboard`,
    recouvrement_scolarite: `${scope}.KpIndicatorWidget.dashboard.recouvrement_scolarite`,
    ecart_theorique_reel: `${scope}.KpIndicatorWidget.dashboard.ecart_theorique_reel`,
    until_today: `${scope}.KpIndicatorWidget.dashboard.until_today`,
    incident: `${scope}.KpIndicatorWidget.dashboard.incident`,
    this_week_dashboard: `${scope}.KpIndicatorWidget.dashboard.this_week_dashboard`,
    allergies: `${scope}.KpIndicatorWidget.dashboard.allergies`,
    children_dashboard: `${scope}.KpIndicatorWidget.dashboard.children_dashboard`,
    confirmed_appointments_dashboard: `${scope}.KpIndicatorWidget.dashboard.confirmed_appointments_dashboard`,
    this_year_dashboard: `${scope}.KpIndicatorWidget.dashboard.this_year_dashboard`,
    this_month_dashboard: `${scope}.KpIndicatorWidget.dashboard.this_month_dashboard`,
    this_day: `${scope}.KpIndicatorWidget.dashboard.this_day`,
    turnover_schooling_compare: `${scope}.SchoolingIndicator.dashboard.turnover_schooling_compare`,
    turnover_schooling_forecast: `${scope}.SchoolingIndicator.dashboard.turnover_schooling_forecast`,
    turnover_schooling_actual: `${scope}.SchoolingIndicator.dashboard.turnover_schooling_actual`,
    exchange_book_list: `${scope}.KpIndicatorWidget.dashboard.exchange_book_list`,
    books_loaning: `${scope}.KpIndicatorWidget.dashboard.books_loaning`,

    title_amount_box: `${scope}.SchoolingIndicator.dashboard.title_amount_box`,
    indicator_imsday: `${scope}.SchoolingIndicator.dashboard.indicator_imsday`,
    indicator_imsday_lastdays: `${scope}.SchoolingIndicator.dashboard.indicator_imsday_lastdays`,
    imsday_indicator_no_sieste: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_no_sieste`,
    imsday_indicator_sieste: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_sieste`,
    imsday_indicator_VERY_WELL: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_VERY_WELL`,
    imsday_indicator_GOOD: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_GOOD`,
    imsday_indicator_NOT_AT_ALL: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_NOT_AT_ALL`,
    imsday_indicator_NOT_GOOD: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_NOT_GOOD`,
    imsday_indicator_EASILY: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_EASILY`,
    imsday_indicator_bowel_mvt: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_bowel_mvt`,
    imsday_indicator_incident: `${scope}.SchoolingIndicator.dashboard.imsday_indicator_incident`,
    total_amount_schooling_and_fees: `${scope}.SchoolingIndicator.dashboard.total_amount_schooling_and_fees`,
    total_amount_schooling: `${scope}.SchoolingIndicator.dashboard.total_amount_schooling`,
    total_amount_additionalfees: `${scope}.SchoolingIndicator.dashboard.total_amount_additionalfees`,
    student_number_box: `${scope}.SchoolingIndicator.dashboard.student_number_box`,
    payment_tuition_type: `${scope}.SchoolingIndicator.dashboard.payment_tuition_type`,
    note_average_box: `${scope}.SchoolingIndicator.dashboard.note_average_box`,
    appointment_dashboard_box: `${scope}.SchoolingIndicator.dashboard.appointment_dashboard_box`,
    appointment_dashboard_empty: `${scope}.SchoolingIndicator.dashboard.appointment_dashboard_empty`,
    appointment_dashboard_bell: `${scope}.SchoolingIndicator.dashboard.appointment_dashboard_bell`,
    dashboard_appointment_open: `${scope}.SchoolingIndicator.dashboard.appointment_open`,
    dashboard_parent_messages_title: `${scope}.SchoolingIndicator.dashboard.parent_messages_title`,
    dashboard_parent_messages_empty: `${scope}.SchoolingIndicator.dashboard.parent_messages_empty`,
    dashboard_parent_messages_open: `${scope}.SchoolingIndicator.dashboard.parent_messages_open`,
    dashboard_parent_messages_image: `${scope}.SchoolingIndicator.dashboard.parent_messages_image`,
    dashboard_parent_messages_attachment: `${scope}.SchoolingIndicator.dashboard.parent_messages_attachment`,
    dashboard_parent_messages_rows: `${scope}.SchoolingIndicator.dashboard.parent_messages_rows`,
    dashboard_parent_messages_rows_oldest: `${scope}.SchoolingIndicator.dashboard.parent_messages_rows_oldest`,
    dashboard_parent_messages_rows_newest: `${scope}.SchoolingIndicator.dashboard.parent_messages_rows_newest`,
    dashboard_parent_messages_audience: `${scope}.SchoolingIndicator.dashboard.parent_messages_audience`,
    dashboard_parent_messages_audience_all: `${scope}.SchoolingIndicator.dashboard.parent_messages_audience_all`,
    dashboard_parent_messages_audience_admin: `${scope}.SchoolingIndicator.dashboard.parent_messages_audience_admin`,
    dashboard_parent_messages_audience_teacher: `${scope}.SchoolingIndicator.dashboard.parent_messages_audience_teacher`,
    dashboard_parent_messages_sort_date: `${scope}.SchoolingIndicator.dashboard.parent_messages_sort_date`,
    dashboard_parent_messages_sort_asc: `${scope}.SchoolingIndicator.dashboard.parent_messages_sort_asc`,
    dashboard_parent_messages_sort_desc: `${scope}.SchoolingIndicator.dashboard.parent_messages_sort_desc`,
    dashboard_library_participation_title: `${scope}.SchoolingIndicator.dashboard.library_participation_title`,
    dashboard_library_participation_period: `${scope}.SchoolingIndicator.dashboard.library_participation_period`,
    dashboard_library_participation_days: `${scope}.SchoolingIndicator.dashboard.library_participation_days`,
    dashboard_library_participation_borrowers: `${scope}.SchoolingIndicator.dashboard.library_participation_borrowers`,
    dashboard_library_participation_rate: `${scope}.SchoolingIndicator.dashboard.library_participation_rate`,
    dashboard_library_participation_school: `${scope}.SchoolingIndicator.dashboard.library_participation_school`,
    dashboard_library_participation_empty: `${scope}.SchoolingIndicator.dashboard.library_participation_empty`,
    dashboard_imsday_completion_title: `${scope}.SchoolingIndicator.dashboard.imsday_completion_title`,
    dashboard_imsday_completion_select_day: `${scope}.SchoolingIndicator.dashboard.imsday_completion_select_day`,
    dashboard_imsday_completion_open_days: `${scope}.SchoolingIndicator.dashboard.imsday_completion_open_days`,
    dashboard_imsday_completion_offset: `${scope}.SchoolingIndicator.dashboard.imsday_completion_offset`,
    dashboard_imsday_completion_open_day: `${scope}.SchoolingIndicator.dashboard.imsday_completion_open_day`,
    dashboard_imsday_completion_filled: `${scope}.SchoolingIndicator.dashboard.imsday_completion_filled`,
    dashboard_imsday_completion_empty: `${scope}.SchoolingIndicator.dashboard.imsday_completion_empty`,
    dashboard_miniclub_participation_title: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_title`,
    dashboard_miniclub_participation_global_rate: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_global_rate`,
    dashboard_miniclub_participation_places: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_places`,
    dashboard_miniclub_participation_enrolled: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_enrolled`,
    dashboard_miniclub_participation_remaining: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_remaining`,
    dashboard_miniclub_participation_active_clubs: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_active_clubs`,
    dashboard_miniclub_participation_per_club: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_per_club`,
    dashboard_miniclub_participation_seats: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_seats`,
    dashboard_miniclub_participation_empty: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_empty`,
    dashboard_miniclub_participation_global: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_global`,
    dashboard_miniclub_participation_chart_caption: `${scope}.SchoolingIndicator.dashboard.miniclub_participation_chart_caption`,

    rdv_type: `${scope}.page.appointment_calendar.rdv_type`,
    rdv_read_employee_feedback: `${scope}.page.appointment_calendar.rdv_read_employee_feedback`,
    rdv_read_report_feedback: `${scope}.page.appointment_calendar.rdv_read_report_feedback`,
    rdv_read_cancel_feedback: `${scope}.page.appointment_calendar.rdv_read_cancel_feedback`,
    rdv_read_parent_feedback: `${scope}.page.appointment_calendar.rdv_read_parent_feedback`,
    rdv_read_parent_noresponse_yet: `${scope}.page.appointment_calendar.rdv_read_parent_noresponse_yet`,
    rdv_read_parent_wait_response: `${scope}.page.appointment_calendar.rdv_read_parent_wait_response`,
    rdv_read_employee_which_outcome: `${scope}.page.appointment_calendar.rdv_read_employee_which_outcome`,
    rdv_read_title_employee_report: `${scope}.page.appointment_calendar.rdv_read_title_employee_report`,
    rdv_read_title_parent_report: `${scope}.page.appointment_calendar.rdv_read_title_parent_report`,
    rdv_read_title_someone_report: `${scope}.page.appointment_calendar.rdv_read_title_someone_report`,
    rdv_read_title_confirm: `${scope}.page.appointment_calendar.rdv_read_title_confirm`,
    rdv_read_title_employee_cancel: `${scope}.page.appointment_calendar.rdv_read_title_employee_cancel`,
    rdv_read_title_someone_cancel: `${scope}.page.appointment_calendar.rdv_read_title_someone_cancel`,
    rdv_read_title_parent_cancel: `${scope}.page.appointment_calendar.rdv_read_title_parent_cancel`,
    rdv_read_title_confirm_rapport: `${scope}.page.appointment_calendar.rdv_read_title_confirm_rapport`,
    rdv_read_title_notheld_rapport: `${scope}.page.appointment_calendar.rdv_read_title_notheld_rapport`,
    class_effectif: `${scope}.page.appointment_calendar.class_effectif`,
    add_normal: `${scope}.page.appointment_calendar.add_normal`,
    comment: `${scope}.page.appointment_calendar.comment`,
    add_preset: `${scope}.page.appointment_calendar.add_preset`,
    add_appointment: `${scope}.page.appointment_calendar.add_appointment`,
    type_normal: `${scope}.page.appointment_calendar.type_normal`,
    type_preset: `${scope}.page.appointment_calendar.type_preset`,
    all_profiles: `${scope}.page.appointment_calendar.all_profiles`,
    all_classes: `${scope}.page.appointment_calendar.all_classes`,
    user_appointment_list: `${scope}.page.appointment_calendar.user_appointment_list`,
    normal_title: `${scope}.page.appointment_calendar.dialog.form.normal_title`,
    choose_interlocutor: `${scope}.page.appointment_calendar.dialog.form.choose_interlocutor`,
    choose_child: `${scope}.page.appointment_calendar.dialog.form.choose_child`,
    preset_title: `${scope}.page.appointment_calendar.dialog.form.preset_title`,
    rdv_filter_title: `${scope}.page.appointment_calendar.dialog.form.rdv_filter_title`,
    dialog_cancel: `${scope}.page.appointment_calendar.dialog.form.actions.dialog_cancel`,
    dialog_close: `${scope}.page.appointment_calendar.dialog.form.actions.dialog_close`,
    dialog_delete: `${scope}.page.appointment_calendar.dialog.form.actions.dialog_delete`,
    dialog_post: `${scope}.page.appointment_calendar.dialog.form.actions.dialog_post`,
    appointment_radio: `${scope}.page.appointment_calendar.dialog.form.radio.appointment_radio`,
    preset_appointment: `${scope}.page.appointment_calendar.dialog.form.radio.preset_appointment`,
    rdv_status_libelle: `${scope}.page.appointment_calendar.rdv_status_libelle`,
    rdv_requested_libelle: `${scope}.page.appointment_calendar.rdv_requested_libelle`,
    title_appointment: `${scope}.page.appointment_calendar.dialog.form.input.title_appointment`,
    title_document_optional: `${scope}.page.appointment_calendar.dialog.form.input.title_document_optional`,
    appointment_status: `${scope}.page.appointment_calendar.dialog.form.input.appointment_status`,
    appointment_deleted: `${scope}.page.appointment_calendar.dialog.form.input.appointment_deleted`,
    appointment_not_held: `${scope}.page.appointment_calendar.dialog.form.input.appointment_not_held`,
    appointment_cancel: `${scope}.page.appointment_calendar.dialog.form.input.appointment_cancel`,
    appointment_confirm: `${scope}.page.appointment_calendar.dialog.form.input.appointment_confirm`,
    appointment_past: `${scope}.page.appointment_calendar.dialog.form.input.appointment_past`,
    appointment_current: `${scope}.page.appointment_calendar.dialog.form.input.appointment_current`,
    appointment_upcoming: `${scope}.page.appointment_calendar.dialog.form.input.appointment_upcoming`,
    appointment_creno: `${scope}.page.appointment_calendar.dialog.form.input.appointment_creno`,
    appointment_done: `${scope}.page.appointment_calendar.dialog.form.input.appointment_done`,
    appointment_not_respected: `${scope}.page.appointment_calendar.dialog.form.input.appointment_not_respected`,
    appointment_report: `${scope}.page.appointment_calendar.dialog.form.input.appointment_report`,
    appointment_reopen: `${scope}.page.appointment_calendar.dialog.form.input.appointment_reopen`,
    appointment_report_confirm: `${scope}.page.appointment_calendar.dialog.form.input.appointment_report_confirm`,
    appointment_partial_confirm: `${scope}.page.appointment_calendar.dialog.form.input.appointment_partial_confirm`,
    appointment_wait: `${scope}.page.appointment_calendar.dialog.form.input.appointment_wait`,
    description_appointment: `${scope}.page.appointment_calendar.dialog.form.input.description_appointment`,
    class_preset: `${scope}.page.appointment_calendar.dialog.form.input.class_preset`,
    duration_preset: `${scope}.page.appointment_calendar.dialog.form.input.duration_preset`,
    deadline_rdv: `${scope}.page.appointment_calendar.dialog.form.input.deadline_rdv`,
    deadline_rdv_date: `${scope}.page.appointment_calendar.dialog.form.input.deadline_rdv_date`,
    admin_override_parent_appointment: `${scope}.page.appointment_calendar.dialog.form.input.admin_override_parent_appointment`,
    appointment_cancel_report_reason: `${scope}.page.appointment_calendar.dialog.form.input.appointment_cancel_report_reason`,
    appointment_cancel_report_reason_required: `${scope}.page.appointment_calendar.dialog.form.input.appointment_cancel_report_reason_required`,
    appointment_parent_reason: `${scope}.page.appointment_calendar.dialog.form.input.appointment_parent_reason`,
    appointment_more: `${scope}.page.appointment_calendar.show_more`,
    appointment_more_title: `${scope}.page.appointment_calendar.show_more_title`,
    appointment_slot_busy: `${scope}.page.appointment_calendar.dialog.form.input.appointment_slot_busy`,
    preset_child_choice: `${scope}.page.appointment_calendar.preset_child_choice`,
    auto_save_progress: `${scope}.page.appointment_calendar.auto_save_progress`,
    child_notified: `${scope}.page.appointment_calendar.child_notified`,
    child_not_notified: `${scope}.page.appointment_calendar.child_not_notified`,
    notify_preset_children: `${scope}.page.appointment_calendar.notify_preset_children`,
    notify_all: `${scope}.page.appointment_calendar.notify_all`,
    notify_not_yet: `${scope}.page.appointment_calendar.notify_not_yet`,
    assign_slot_to_parent: `${scope}.page.appointment_calendar.assign_slot_to_parent`,
    assign_slot_available: `${scope}.page.appointment_calendar.assign_slot_available`,
    assign_slot_current_choice: `${scope}.page.appointment_calendar.assign_slot_current_choice`,
    assign_slot_choices_title: `${scope}.page.appointment_calendar.assign_slot_choices_title`,
    assign_slot_no_parent: `${scope}.page.appointment_calendar.assign_slot_no_parent`,
    assign_slot_cancel_choice: `${scope}.page.appointment_calendar.assign_slot_cancel_choice`,
    assign_slot_cancel_choice_help: `${scope}.page.appointment_calendar.assign_slot_cancel_choice_help`,
    assign_slot_required: `${scope}.page.appointment_calendar.assign_slot_required`,
    preset_children_updated: `${scope}.page.appointment_calendar.preset_children_updated`,
    preset_past_locked: `${scope}.page.appointment_calendar.preset_past_locked`,
    appointment_outcome_check: `${scope}.page.appointment_calendar.appointment_outcome_check`,
    //export_xls: `${scope}.page.appointment_list.datagrid.export_xls`,
    compose_message: `${scope}.page.message_center.compose_message`,
    compose_ticket: `${scope}.page.message_center.compose_ticket`,
    conversation_list: `${scope}.page.message_center.conversation_list`,
    type_message: `${scope}.page.message_center.type_message`,
    chat_list_empty_message: `${scope}.page.message_center.chat_list_empty_message`,
    chat_shortcuts_title: `${scope}.page.message_center.chat_shortcuts_title`,
    chat_shortcuts_send: `${scope}.page.message_center.chat_shortcuts_send`,
    chat_shortcuts_newline: `${scope}.page.message_center.chat_shortcuts_newline`,
    chat_emoji: `${scope}.page.message_center.chat_emoji`,
    chat_attach_file: `${scope}.page.message_center.chat_attach_file`,
    please_select_parent: `${scope}.page.message_center.please_select_parent`,
    please_select_child: `${scope}.page.message_center.please_select_child`,
    please_write_message: `${scope}.page.message_center.please_write_message`,
    opened_space: `${scope}.page.message_center.opened_space`,
    closed_space: `${scope}.page.message_center.closed_space`,
    online_space: `${scope}.page.message_center.online_space`,
    offline_space: `${scope}.page.message_center.offline_space`,
    object_message: `${scope}.page.message_center.object_message`,
    folder: `${scope}.page.message_center.folder`,
    no_folder: `${scope}.page.message_center.no_folder`,
    unfile_drop_hint: `${scope}.page.message_center.unfile_drop_hint`,
    create_new_folder: `${scope}.page.message_center.create_new_folder`,
    new_folder_name: `${scope}.page.message_center.new_folder_name`,
    folder_helper: `${scope}.page.message_center.folder_helper`,
    please_write_folder_name: `${scope}.page.message_center.please_write_folder_name`,
    create_folder_title: `${scope}.page.message_center.create_folder_title`,
    folder_name_exists: `${scope}.page.message_center.folder_name_exists`,
    new_folder_action: `${scope}.page.message_center.new_folder_action`,
    move_to_folder_action: `${scope}.page.message_center.move_to_folder_action`,
    folder_actions: `${scope}.page.message_center.folder_actions`,
    move_multiple_spaces_action: `${scope}.page.message_center.move_multiple_spaces_action`,
    move_spaces_title: `${scope}.page.message_center.move_spaces_title`,
    destination_folder: `${scope}.page.message_center.destination_folder`,
    search_space_placeholder: `${scope}.page.message_center.search_space_placeholder`,
    select_all_spaces: `${scope}.page.message_center.select_all_spaces`,
    no_space_selected: `${scope}.page.message_center.no_space_selected`,
    spaces_selected: `${scope}.page.message_center.spaces_selected`,
    no_space_result: `${scope}.page.message_center.no_space_result`,
    move_spaces_submit: `${scope}.page.message_center.move_spaces_submit`,
    lock_spaces_action: `${scope}.page.message_center.lock_spaces_action`,
    unlock_spaces_action: `${scope}.page.message_center.unlock_spaces_action`,
    lock_space_action: `${scope}.page.message_center.lock_space_action`,
    unlock_space_action: `${scope}.page.message_center.unlock_space_action`,
    lock_spaces_title: `${scope}.page.message_center.lock_spaces_title`,
    unlock_spaces_title: `${scope}.page.message_center.unlock_spaces_title`,
    lock_spaces_hint: `${scope}.page.message_center.lock_spaces_hint`,
    unlock_spaces_hint: `${scope}.page.message_center.unlock_spaces_hint`,
    no_open_space: `${scope}.page.message_center.no_open_space`,
    no_closed_space: `${scope}.page.message_center.no_closed_space`,
    folder_open_status: `${scope}.page.message_center.folder_open_status`,
    folder_closed_status: `${scope}.page.message_center.folder_closed_status`,
    close_space: `${scope}.page.message_center.close_space`,
    confirm_close_space: `${scope}.page.message_center.confirm_close_space`,
    close_ticket_title: `${scope}.page.message_center.close_ticket_title`,
    delete_ticket_title: `${scope}.page.message_center.delete_ticket_title`,
    delete_space: `${scope}.page.message_center.delete_space`,
    confirm_delete_space: `${scope}.page.message_center.confirm_delete_space`,
    please_write_subject_message: `${scope}.page.message_center.please_write_subject_message`,
    add_action: `${scope}.page.config.school_period.toolbar_top.add_action`,
    generer_action: `${scope}.page.config.school_period.toolbar_top.generer_action`,
    delete_action: `${scope}.page.config.school_period.toolbar_top.delete_action`,
    printer_action: `${scope}.page.config.school_period.toolbar_top.printer_action`,

    school_period_year: `${scope}.page.config.school_period.table.columns.school_period_year`,
    school_period: `${scope}.page.config.school_period.table.columns.school_period`,
    start_period: `${scope}.page.config.school_period.table.columns.start_period`,
    end_period: `${scope}.page.config.school_period.table.columns.end_period`,

    dialog_title_period: `${scope}.page.config.school_period.dialog.form.dialog_title_period`,
    dialog_edit_title_period: `${scope}.page.config.school_period.dialog.form.dialog_edit_title_period`,
    year_period: `${scope}.page.config.school_period.dialog.form.year_period`,
    title_school_period: `${scope}.page.config.school_period.dialog.form.title_school_period`,
    school_day_title: `${scope}.page.config.period.school_day_title`,
    day_off: `${scope}.page.config.period.day_off`,
    day_open: `${scope}.page.config.period.day_open`,
    dialog_title_canteen_week: `${scope}.page.config.canteen_week.dialog.form.dialog_title_canteen_week`,
    dialog_edit_title_canteen_week: `${scope}.page.config.canteen_week.dialog.form.dialog_edit_title_canteen_week`,
    title_canteen_week: `${scope}.page.config.canteen_week.dialog.form.title_canteen_week`,
    dialog_title_personal_type: `${scope}.page.config.school_period.dialog.form.dialog_title_personal_type`,
    dialog_edit_title_job: `${scope}.page.config.school_period.dialog.form.dialog_edit_title_job`,
    title_personal_type: `${scope}.page.config.school_period.dialog.form.title_personal_type`,
    dialog_job_role: `${scope}.page.config.school_period.dialog.form.dialog_job_role`,

    dialog_title_school_document_type: `${scope}.page.config.school_document.dialog.form.dialog_title_school_document_type`,
    dialog_edit_title_school_document_type: `${scope}.page.config.school_document.dialog.form.dialog_edit_title_school_document_type`,
    title_school_document_type: `${scope}.page.config.school_document.dialog.form.title_school_document_type`,
    title_document_type: `${scope}.page.config.school_document.dialog.form.title_document_type`,
    dialog_title_inscription_file_type: `${scope}.page.config.inscription_file.dialog.form.dialog_title_inscription_file_type`,
    dialog_edit_title_inscription_file_type: `${scope}.page.config.inscription_file.dialog.form.dialog_edit_title_inscription_file_type`,
    title_inscription_file_type: `${scope}.page.config.inscription_file.dialog.form.title_inscription_file_type`,
    inscription_file_type: `${scope}.page.config.inscription_file.dialog.form.inscription_file_type`,
    sub_folder_type: `${scope}.page.config.folder.sub_folder_type`,
    dialog_title_sub_folder_type: `${scope}.page.config.folder.dialog.form.dialog_title_sub_folder_type`,
    dialog_edit_title_sub_folder_type: `${scope}.page.config.folder.dialog.form.dialog_edit_title_sub_folder_type`,
    folder_type: `${scope}.page.config.folder.folder_type`,
    dialog_title_folder_type: `${scope}.page.config.folder.dialog.form.dialog_title_folder_type`,
    dialog_edit_title_folder_type: `${scope}.page.config.folder.dialog.form.dialog_edit_title_folder_type`,
    dialog_folder_type_file: `${scope}.page.config.folder.dialog.form.dialog_folder_type_file`,
    image_rights: `${scope}.page.config.image_rights.table_columns.image_rights`,
    dialog_title_image_right: `${scope}.page.config.image_rights.dialog.form.dialog_title_image_right`,
    dialog_edit_title_image_right: `${scope}.page.config.image_rights.dialog.form.dialog_edit_title_image_right`,

    dialog_title_dish_config: `${scope}.page.config.dish.dialog.form.dialog_title_dish_config`,
    dialog_title_edit_dish: `${scope}.page.config.dish.dialog.form.dialog_title_edit_dish`,
    dish_type_config: `${scope}.page.config.dish.dialog.form.dish_type_config`,
    title_dish_config: `${scope}.page.config.dish.dialog.form.title_dish_config`,
    appointment_type: `${scope}.page.config.appointment_type.table_columns.appointment_type`,
    title_appoint_type_config: `${scope}.page.config.appointment_type.dialog.form.title_appoint_type_config`,
    edit_title_appoint_type_config: `${scope}.page.config.appointment_type.dialog.form.edit_title_appoint_type_config`,
    input_appoint_type: `${scope}.page.config.appointment_type.dialog.form.input_appoint_type`,

    antidate_du: `${scope}.page.config.schooling.antidate_du`,
    proforma_du: `${scope}.page.config.schooling.proforma_du`,
    generer_facture: `${scope}.page.config.schooling.generer_facture`,
    generer_paiement: `${scope}.page.config.schooling.generer_paiement`,
    notifier_parent: `${scope}.page.config.schooling.notifier_parent`,
    schooling_echeance_label: `${scope}.page.config.schooling.schooling_echeance_label`,
    schooling_add_payment: `${scope}.page.config.schooling.schooling_add_payment`,
    schooling_payment_list: `${scope}.page.config.schooling.schooling_payment_list`,
    schooling_proforma_invoice: `${scope}.page.config.schooling.schooling_proforma_invoice`,
    schooling_fees_label: `${scope}.page.config.schooling.schooling_fees_label`,
    schooling_payment_period: `${scope}.page.config.schooling.schooling_payment_period`,
    schooling_fees: `${scope}.page.config.schooling.schooling_fees`,
    class_fees: `${scope}.page.config.schooling.class_fees`,
    fees: `${scope}.page.config.schooling.fees`,
    schooling_fees_title: `${scope}.page.config.schooling.schooling_fees_title`,
    schooling_fees_type: `${scope}.page.config.schooling.schooling_fees_type`,
    schooling_versement_etat: `${scope}.page.config.schooling.schooling_versement_etat`,
    schooling_save_payment: `${scope}.page.config.schooling.schooling_save_payment`,
    schooling_total_payment: `${scope}.page.config.schooling.schooling_total_payment`,
    schooling_total_restant: `${scope}.page.config.schooling.schooling_total_restant`,
    schooling_total_montant: `${scope}.page.config.schooling.schooling_total_montant`,
    montant_to_save: `${scope}.page.config.schooling.montant_to_save`,
    schooling_restant_apayer: `${scope}.page.config.schooling.schooling_restant_apayer`,
    schooling_total_payment_done: `${scope}.page.config.schooling.schooling_total_payment_done`,
    schooling_total_new_payment: `${scope}.page.config.schooling.schooling_total_new_payment`,
    schooling_fees_title_custom: `${scope}.page.config.schooling.schooling_fees_title_custom`,
    schooling_other_fees_list: `${scope}.page.config.schooling.schooling_other_fees_list`,
    schooling: `${scope}.page.config.schooling.schooling`,
    dialog_title_schooling: `${scope}.page.config.schooling.dialog.form.dialog_title_schooling`,
    dialog_edit_title_schooling: `${scope}.page.config.schooling.dialog.form.dialog_edit_title_schooling`,
    schooling_profile: `${scope}.page.config.schooling.dialog.form.input.schooling_profile`,
    schooling_amount: `${scope}.page.config.schooling.dialog.form.input.schooling_amount`,
    schooling_period_payment: `${scope}.page.config.schooling.table_grid.schooling_period_payment`,
    payment_date_limite: `${scope}.page.config.schooling.table_grid.payment_date_limite`,
    date_limite: `${scope}.page.config.schooling.table_grid.date_limite`,
    schooling_rappel_payment: `${scope}.page.config.schooling.table_grid.schooling_rappel_payment`,
    dialog_title_schooling_payment_period: `${scope}.page.config.schooling.dialog.form.dialog_title_schooling_payment_period`,
    dialog_edit_title_schooling_payment_period: `${scope}.page.config.schooling.dialog.form.dialog_edit_title_schooling_payment_period`,
    schooling_fees_obligatory: `${scope}.page.config.schooling.schooling_fees.table_grid.schooling_fees_obligatory`,
    schooling_fees_echeance: `${scope}.page.config.schooling.schooling_fees.table_grid.schooling_fees_echeance`,
    dialog_title_additional_fees: `${scope}.page.config.schooling.schooling_fees.dialog.form.dialog_title_additional_fees`,
    dialog_edit_title_additional_fees: `${scope}.page.config.schooling.schooling_fees.dialog.form.dialog_edit_title_additional_fees`,
    additional_fees_title: `${scope}.page.config.schooling.schooling_fees.dialog.form.input.additional_fees_title`,

    title_password_profile: `${scope}.page.profile.title_password_profile`,
    title_username_profile: `${scope}.page.profile.title_username_profile`,
    username_profile: `${scope}.page.profile.username_profile`,
    profile_new_username: `${scope}.page.profile.new_username_profile`,
    profile_current_password: `${scope}.page.profile.current_password_profile`,
    profile_username_available: `${scope}.page.profile.username_available_profile`,
    profile_username_taken: `${scope}.page.profile.username_taken_profile`,
    profile_username_checking: `${scope}.page.profile.username_checking_profile`,
    profile_username_same: `${scope}.page.profile.username_same_profile`,
    profile_username_required: `${scope}.page.profile.username_required_profile`,
    profile_current_password_required: `${scope}.page.profile.current_password_required_profile`,
    profile_current_password_invalid: `${scope}.page.profile.current_password_invalid_profile`,
    old_password_profile: `${scope}.page.profile.old_password_profile`,
    new_password_profile: `${scope}.page.profile.new_password_profile`,
    confirm_new_password_profile: `${scope}.page.profile.confirm_new_password_profile`,
    password_not_match_profile: `${scope}.page.profile.password_not_match_profile`,
    title_profile: `${scope}.page.profile.title_profile`,

    dialog_title_personal: `${scope}.page.personal.dialog.form.dialog_title_personal`,
    dialog_title_edit_personal: `${scope}.page.personal.dialog.form.dialog_title_edit_personal`,
    firstname_personal: `${scope}.page.personal.dialog.form.firstname_personal`,
    lastname_personal: `${scope}.page.personal.dialog.form.lastname_personal`,
    birth_date_personal: `${scope}.page.personal.dialog.form.birth_date_personal`,
    hire_date_personal: `${scope}.page.personal.dialog.form.hire_date_personal`,
    email_personal: `${scope}.page.personal.dialog.form.email_personal`,
    phone_number_personal: `${scope}.page.personal.dialog.form.phone_number_personal`,
    type_personal: `${scope}.page.personal.dialog.form.type_personal`,
    genre_personal: `${scope}.page.personal.dialog.form.genre_personal`,
    more_info_personal: `${scope}.page.personal.dialog.form.more_info_personal`,
    job_name_personal: `${scope}.page.personal.dialog.form.job_name_personal`,
    post_personal: `${scope}.page.personal.dialog.form.post_personal`,
    table_h_person_avatar: `${scope}.page.personal.table.header.table_h_person_avatar`,
    table_h_person_email: `${scope}.page.personal.table.header.table_h_person_email`,
    table_h_person_phone: `${scope}.page.personal.table.header.table_h_person_phone`,
    table_h_account_status: `${scope}.page.personal.table.header.table_h_account_status`,
    table_h_person_job: `${scope}.page.personal.table.header.table_h_person_job`,
    personal_delete_title: `${scope}.page.personal.confirm.delete_title`,
    personal_delete_one: `${scope}.page.personal.confirm.delete_one`,
    personal_delete_many: `${scope}.page.personal.confirm.delete_many`,

    dialog_title_child: `${scope}.page.children.dialog.form.dialog_title_child`,
    dialog_title_edit_child: `${scope}.page.children.dialog.form.dialog_title_edit_child`,
    identity_child: `${scope}.page.children.dialog.form.identity_child`,
    parent_child: `${scope}.page.children.dialog.form.parent_child`,
    other_details_child: `${scope}.page.children.dialog.form.other_details_child`,
    emergency_child: `${scope}.page.children.dialog.form.emergency_child`,
    emergency_contact_child: `${scope}.page.children.dialog.form.emergency_contact_child`,
    firstname_child: `${scope}.page.children.dialog.form.firstname_child`,
    lastname_child: `${scope}.page.children.dialog.form.lastname_child`,
    birth_date_child: `${scope}.page.children.dialog.form.birth_date_child`,
    classroom_child: `${scope}.page.children.dialog.form.classroom_child`,
    scolaritee_annee: `${scope}.page.children.dialog.form.scolaritee_annee`,
    nationality_child: `${scope}.page.children.dialog.form.nationality_child`,
    country: `${scope}.page.children.dialog.form.country`,
    genre_child: `${scope}.page.children.dialog.form.genre_child`,
    address_child: `${scope}.page.children.dialog.form.address_child`,
    phone_number_child: `${scope}.page.children.dialog.form.phone_number_child`,
    email_child: `${scope}.page.children.dialog.form.email_child`,
    father_child: `${scope}.page.children.dialog.form.father_child`,
    father_phone_child: `${scope}.page.children.dialog.form.father_phone_child`,
    mother_child: `${scope}.page.children.dialog.form.mother_child`,
    mother_phone_child: `${scope}.page.children.dialog.form.mother_phone_child`,
    mother_email_child: `${scope}.page.children.dialog.form.mother_email_child`,
    father_email_child: `${scope}.page.children.dialog.form.father_email_child`,
    health_detail_child: `${scope}.page.children.dialog.form.health_detail_child`,
    allergies_child: `${scope}.page.children.dialog.form.allergies_child`,
    food_restriction_child: `${scope}.page.children.dialog.form.food_restriction_child`,
    health_issue_child: `${scope}.page.children.dialog.form.health_issue_child`,
    siblings_child: `${scope}.page.children.dialog.form.siblings_child`,
    empty_siblings: `${scope}.page.children.dialog.form.empty_siblings`,
    registration_file_child: `${scope}.page.children.dialog.form.registration_file_child`,
    select_file_child: `${scope}.page.children.dialog.form.select_file_child`,
    image_rights_child: `${scope}.page.children.dialog.form.image_rights_child`,
    emergency_contact_one_child: `${scope}.page.children.dialog.form.emergency_contact_one_child`,
    emergency_contact_one_phone_child: `${scope}.page.children.dialog.form.emergency_contact_one_phone_child`,
    authorization_person_child: `${scope}.page.children.dialog.form.authorization_person_child`,
    required_field_child: `${scope}.page.children.dialog.form.required_field_child`,
    add_person_authorization_child: `${scope}.page.children.dialog.form.add_person_authorization_child`,
    table_h_ims_day_date: `${scope}.page.children.table.header.table_h_ims_day_date`,
    table_h_ims_day_naptime: `${scope}.page.children.table.header.table_h_ims_day_naptime`,
    table_h_ims_day_eat: `${scope}.page.children.table.header.table_h_ims_day_eat`,
    table_h_ims_day_obs_general: `${scope}.page.children.table.header.table_h_ims_day_obs_general`,
    table_h_child_avatar: `${scope}.page.children.table.header.table_h_child_avatar`,
    table_h_child_name: `${scope}.page.children.table.header.table_h_child_name`,
    table_h_child_firstname: `${scope}.page.children.table.header.table_h_child_firstname`,
    table_h_child_lastname: `${scope}.page.children.table.header.table_h_child_lastname`,
    table_h_fullname: `${scope}.page.children.table.header.table_h_fullname`,
    table_h_child_birthday: `${scope}.page.children.table.header.table_h_child_birthday`,
    table_h_child_gender: `${scope}.page.children.table.header.table_h_child_gender`,
    table_h_child_classroom: `${scope}.page.children.table.header.table_h_child_classroom`,
    profile_child: `${scope}.page.children.dialog.form.profile_child`,
    children_per_classroom: `${scope}.page.children.list.per_classroom`,
    children_list_title: `${scope}.page.children.list.list_title`,
    child_view_list: `${scope}.page.children.list.view_list`,
    child_view_classroom: `${scope}.page.children.list.view_classroom`,
    child_search_placeholder: `${scope}.page.children.list.search_placeholder`,
    child_filter_all: `${scope}.page.children.list.filter_all`,
    child_unassigned_classroom: `${scope}.page.children.list.unassigned_classroom`,
    child_no_result: `${scope}.page.children.list.no_result`,
    child_search_parent_placeholder: `${scope}.page.children.list.search_parent_placeholder`,
    child_filter_age: `${scope}.page.children.list.filter_age`,
    child_age_0_2: `${scope}.page.children.list.age_0_2`,
    child_age_3_5: `${scope}.page.children.list.age_3_5`,
    child_age_6_8: `${scope}.page.children.list.age_6_8`,
    child_age_9_12: `${scope}.page.children.list.age_9_12`,
    child_age_13_plus: `${scope}.page.children.list.age_13_plus`,
    child_count_summary: `${scope}.page.children.list.count_summary`,
    child_search_allergy: `${scope}.page.children.list.search_allergy`,
    child_search_health: `${scope}.page.children.list.search_health`,
    parent_contact_info: `${scope}.page.children.list.parent_contact_info`,
    no_parent_info: `${scope}.page.children.list.no_parent_info`,
    child_open_edit: `${scope}.page.children.list.open_edit`,
    return_children_list: `${scope}.page.children.form.return_children_list`,
    main_parent: `${scope}.page.children.form.main_parent`,
    all_mother_information: `${scope}.page.children.form.all_mother_information`,
    all_father_information: `${scope}.page.children.form.all_father_information`,
    incorrect_email: `${scope}.page.children.form.incorrect_email`,
    warning_child_registration: `${scope}.page.children.form.warning_child_registration`,
    send_email_to_parent: `${scope}.page.children.form.send_email_to_parent`,
    call_parent: `${scope}.page.children.form.call_parent`,

    table_h_available: `${scope}.page.bibliotheque.table.header.table_h_available`,
    table_h_nom: `${scope}.page.bibliotheque.table.header.table_h_nom`,
    table_h_livre: `${scope}.page.bibliotheque.table.header.table_h_livre`,
    table_h_emprunt: `${scope}.page.bibliotheque.table.header.table_h_emprunt`,
    table_h_horsdelai: `${scope}.page.bibliotheque.table.header.table_h_horsdelai`,
    table_h_emprunt_date: `${scope}.page.bibliotheque.table.header.table_h_emprunt_date`,
    table_h_emprunt_retour: `${scope}.page.bibliotheque.table.header.table_h_emprunt_retour`,
    table_h_emprunt_datedemande: `${scope}.page.bibliotheque.table.header.table_h_emprunt_datedemande`,
    table_h_emprunt_deadline: `${scope}.page.bibliotheque.table.header.table_h_emprunt_deadline`,
    table_h_parent: `${scope}.page.bibliotheque.table.header.table_h_parent`,
    table_h_enfant: `${scope}.page.bibliotheque.table.header.table_h_enfant`,
    table_h_catlivre: `${scope}.page.bibliotheque.table.header.table_h_catlivre`,
    table_h_auteur: `${scope}.page.bibliotheque.table.header.table_h_auteur`,
    table_h_agemin: `${scope}.page.bibliotheque.table.header.table_h_agemin`,
    table_h_agemax: `${scope}.page.bibliotheque.table.header.table_h_agemax`,
    table_h_langue: `${scope}.page.bibliotheque.table.header.table_h_langue`,
    table_h_empruntmaxjour: `${scope}.page.bibliotheque.table.header.table_h_empruntmaxjour`,
    table_h_prix: `${scope}.page.bibliotheque.table.header.table_h_prix`,
    table_h_quantite: `${scope}.page.bibliotheque.table.header.table_h_quantite`,
    table_h_photo: `${scope}.page.bibliotheque.table.header.table_h_photo`,

    emergency_contact_two_child: `${scope}.page.children.dialog.form.emergency_contact_two_child`,
    emergency_contact_two_phone_child: `${scope}.page.children.dialog.form.emergency_contact_two_phone_child`,
    add_to_menu_year: `${scope}.page.menu_year.dialog.form.add_to_menu_year`,
    empty_tab: `${scope}.page.menu_year.tab_panel.empty_tab`,
    starter_menu_year: `${scope}.page.menu_year.dialog.form.starter_menu_year`,
    dish_menu_year: `${scope}.page.menu_year.dialog.form.dish_menu_year`,
    dessert_menu_year: `${scope}.page.menu_year.dialog.form.dessert_menu_year`,
    add_new_menu_year: `${scope}.page.menu_year.dialog.form.add_new_menu_year`,
    edit_menu_year: `${scope}.page.menu_year.dialog.form.edit_menu_year`,
    add_dish_year: `${scope}.page.menu_year.dialog.form.add_dish_year`,
    pause_menu_year: `${scope}.page.menu_year.dialog.form.pause_menu_year`,
    play_menu_year: `${scope}.page.menu_year.dialog.form.play_menu_year`,
    total_menu_year: `${scope}.page.menu_year.dialog.form.total_menu_year`,
    generate_menu_other_week: `${scope}.page.menu_year.dialog.form.generate_menu_other_week`,
    generate_menu_from_week_title: `${scope}.page.menu_year.dialog.form.generate_menu_from_week_title`,
    generate_menu_other_week_available: `${scope}.page.menu_year.dialog.form.generate_menu_other_week_available`,
    generate_form_week_type: `${scope}.page.menu_year.dialog.form.generate_form_week_type`,
    generate_form_specific_week: `${scope}.page.menu_year.dialog.form.generate_form_specific_week`,
    generate_over_specific_period: `${scope}.page.menu_year.dialog.form.generate_over_specific_period`,
    generate_form_week_select_one: `${scope}.page.menu_year.dialog.form.generate_form_week_select_one`,
    generate_form_week_select_two: `${scope}.page.menu_year.dialog.form.generate_form_week_select_two`,
    generate_error_no_active_period: `${scope}.page.menu_year.dialog.form.generate_error_no_active_period`,
    generate_error_no_last_week: `${scope}.page.menu_year.dialog.form.generate_error_no_last_week`,
    generate_error_selection: `${scope}.page.menu_year.dialog.form.generate_error_selection`,
    generate_error_no_week_to_fill: `${scope}.page.menu_year.dialog.form.generate_error_no_week_to_fill`,
    generate_error_no_source_menu: `${scope}.page.menu_year.dialog.form.generate_error_no_source_menu`,
    dialog_title_classroom: `${scope}.page.classroom.dialog.form.dialog_title_classroom`,
    dialog_edit_title_classroom: `${scope}.page.classroom.dialog.form.dialog_edit_title_classroom`,
    dialog_input_classroom: `${scope}.page.classroom.dialog.form.dialog_input_classroom`,
    dialog_table_header_classroom: `${scope}.page.classroom.dialog.form.dialog_table_header_classroom`,
    dialog_table_header_classroom_color: `${scope}.page.classroom.dialog.form.dialog_table_header_classroom_color`,
    classroom_color: `${scope}.page.classroom.dialog.form.classroom_color`,
    classroom_color_random: `${scope}.page.classroom.dialog.form.classroom_color_random`,
    menu_year_week: `${scope}.page.menu_year.submenu.menu_year_week`,
    menu_year_calendar: `${scope}.page.menu_year.submenu.menu_year_calendar`,
    title_menu_year_calendar: `${scope}.page.menu_year.edit.title_menu_year_calendar`,

    dialog_tab_hd_club_illustration: `${scope}.page.mini_club.form.dialog_tab_hd_club_illustration`,
    dialog_tab_hd_club_title: `${scope}.page.mini_club.form.dialog_tab_hd_club_title`,
    dialog_tab_hd_club_start_time: `${scope}.page.mini_club.form.dialog_tab_hd_club_start_time`,
    dialog_tab_hd_club_time: `${scope}.page.mini_club.form.dialog_tab_hd_club_time`,
    dialog_tab_hd_club_end_time: `${scope}.page.mini_club.form.dialog_tab_hd_club_end_time`,
    dialog_tab_hd_club_number: `${scope}.page.mini_club.form.dialog_tab_hd_club_number`,
    dialog_tab_hd_club_description: `${scope}.page.mini_club.form.dialog_tab_hd_club_description`,
    dialog_tab_hd_club_price: `${scope}.page.mini_club.form.dialog_tab_hd_club_price`,
    dialog_modal_club_title: `${scope}.page.mini_club.form.dialog_modal_club_title`,
    dialog_modal_club_limit: `${scope}.page.mini_club.form.dialog_modal_club_limit`,
    return_mini_club_list: `${scope}.page.mini_club.form.return_mini_club_list`,
    save_edit_mini_club_list: `${scope}.page.mini_club.form.save_edit_mini_club_list`,
    edit_mini_club_list: `${scope}.page.mini_club.form.edit_mini_club_list`,
    registered_mini_club_list: `${scope}.page.mini_club.form.registered_mini_club_list`,
    empty_registered_mini_club: `${scope}.page.mini_club.form.empty_registered_mini_club`,
    duplicate_miniclub: `${scope}.page.mini_club.form.duplicate_miniclub`,
    miniclub_photo_saved: `${scope}.page.mini_club.form.photo_saved`,
    miniclub_photo_uploading: `${scope}.page.mini_club.form.photo_uploading`,
    confirm_desinscrire_miniclub: `${scope}.page.mini_club.form.confirm_desinscrire_miniclub`,
    miniclub_delete_title: `${scope}.page.mini_club.confirm.delete_title`,
    miniclub_delete_one: `${scope}.page.mini_club.confirm.delete_one`,
    miniclub_filter_name: `${scope}.page.mini_club.filter.name`,
    miniclub_filter_status: `${scope}.page.mini_club.filter.status`,
    miniclub_filter_active: `${scope}.page.mini_club.filter.active`,
    miniclub_filter_inactive: `${scope}.page.mini_club.filter.inactive`,
    miniclub_filter_date_from: `${scope}.page.mini_club.filter.date_from`,
    miniclub_filter_date_to: `${scope}.page.mini_club.filter.date_to`,
    miniclub_filter_price_min: `${scope}.page.mini_club.filter.price_min`,
    miniclub_filter_price_max: `${scope}.page.mini_club.filter.price_max`,
    miniclub_filter_all: `${scope}.page.mini_club.filter.all`,
    miniclub_filter_no_result: `${scope}.page.mini_club.filter.no_result`,
    miniclub_search_placeholder: `${scope}.page.mini_club.filter.search_placeholder`,

    marketing_product_photo: `${scope}.page.marketing.table.marketing_product_photo`,
    marketing_product_nom: `${scope}.page.marketing.table.marketing_product_nom`,
    marketing_product_pix: `${scope}.page.marketing.table.marketing_product_pix`,
    marketing_product_quantity: `${scope}.page.marketing.table.marketing_product_quantity`,
    marketing_product_quantity_ordered: `${scope}.page.marketing.table.marketing_product_quantity_ordered`,
    marketing_product_quantity_delivered: `${scope}.page.marketing.table.marketing_product_quantity_delivered`,
    marketing_product_quantity_to_deliver: `${scope}.page.marketing.table.marketing_product_quantity_to_deliver`,
    marketing_delivery_invalid_quantity: `${scope}.page.marketing.table.marketing_delivery_invalid_quantity`,
    marketing_delivery_exceeds_ordered: `${scope}.page.marketing.table.marketing_delivery_exceeds_ordered`,
    marketing_product_stock_alert: `${scope}.page.marketing.table.marketing_product_stock_alert`,
    marketing_product_delivery: `${scope}.page.marketing.table.marketing_product_delivery`,
    marketing_delivery_status_not_delivered: `${scope}.page.marketing.table.marketing_delivery_status_not_delivered`,
    marketing_delivery_status_partial: `${scope}.page.marketing.table.marketing_delivery_status_partial`,
    marketing_delivery_status_delivered: `${scope}.page.marketing.table.marketing_delivery_status_delivered`,
    marketing_product_delete: `${scope}.page.marketing.table.marketing_product_delete`,
    marketing_product_command: `${scope}.page.marketing.table.marketing_product_command`,
    marketing_product_sold: `${scope}.page.marketing.table.marketing_product_sold`,
    marketing_product_in_stock: `${scope}.page.marketing.table.marketing_product_in_stock`,
    marketing_product_waiting_delivery: `${scope}.page.marketing.table.marketing_product_waiting_delivery`,
    marketing_product_quantity_waiting_delivery: `${scope}.page.marketing.table.marketing_product_quantity_waiting_delivery`,
    marketing_delete_title: `${scope}.page.marketing.confirm.delete_title`,
    marketing_delete_one: `${scope}.page.marketing.confirm.delete_one`,
    marketing_delete_many: `${scope}.page.marketing.confirm.delete_many`,
    marketing_empty: `${scope}.page.marketing.empty`,
    marketing_empty_search: `${scope}.page.marketing.empty_search`,
    marketing_empty_filter: `${scope}.page.marketing.empty_filter`,
    dialog_modal_title: `${scope}.page.marketing.form.dialog_modal_title`,
    dialog_modal_edit_title: `${scope}.page.marketing.form.dialog_modal_edit_title`,
    return_product_list: `${scope}.page.marketing.form.return_product_list`,
    orders_product_list: `${scope}.page.marketing.form.orders_product_list`,
    empty_order_product: `${scope}.page.marketing.form.empty_order_product`,
    order_identity_product: `${scope}.page.marketing.form.order_identity_product`,
    date_order_product: `${scope}.page.marketing.form.date_order_product`,


    selection: `${scope}.system.ui.selection`,
    desinscription: `${scope}.system.ui.desinscription`,
    desinscrire: `${scope}.system.ui.desinscrire`,
    historical_loaned: `${scope}.system.ui.historical_loaned`,
    personal_member: `${scope}.system.ui.personal_member`,
    uploadedby: `${scope}.system.ui.uploadedby`,
    createdby: `${scope}.system.ui.createdby`,
    return_list: `${scope}.system.ui.return_list`,
    table_h_agent_caisse: `${scope}.system.ui.table_h_agent_caisse`,
    loading_list_for_notifications: `${scope}.system.ui.loading_list_for_notifications`,
    notification_menu_send: `${scope}.system.ui.notification_menu_send`,
    notification_menu_sent: `${scope}.system.ui.notification_menu_sent`,
    notification_view_details: `${scope}.system.ui.notification_view_details`,
    notification_details: `${scope}.system.ui.notification_details`,
    notification_sent_date: `${scope}.system.ui.notification_sent_date`,
    notification_recipients: `${scope}.system.ui.notification_recipients`,
    notification_sent_empty: `${scope}.system.ui.notification_sent_empty`,
    notification_parents_valid_account_hint: `${scope}.system.ui.notification_parents_valid_account_hint`,
    compose_message_min_length: `${scope}.system.ui.compose_message_min_length`,
    table_page_range: `${scope}.system.ui.table_page_range`,
    table_page_size: `${scope}.system.ui.table_page_size`,
    step_archivage: `${scope}.system.ui.step_archivage`,
    step_yearschool: `${scope}.system.ui.step_yearschool`,
    step_periodeschool: `${scope}.system.ui.step_periodeschool`,
    step_initnewyear: `${scope}.system.ui.step_initnewyear`,
    step_end: `${scope}.system.ui.step_end`,
    archive_info: `${scope}.system.ui.archive_info`,
    last_archive: `${scope}.system.ui.last_archive`,
    generate_start: `${scope}.system.ui.generate_start`,
    newyear_processing_end: `${scope}.system.ui.newyear_processing_end`,
    generate_running: `${scope}.system.ui.generate_running`,
    generate_newyear: `${scope}.system.ui.generate_newyear`,
    newyear_info: `${scope}.system.ui.newyear_info`,
    archive_reinit_done: `${scope}.system.ui.archive_reinit_done`,
    archive_archiver_done: `${scope}.system.ui.archive_archiver_done`,
    archive_download_done: `${scope}.system.ui.archive_download_done`,
    archive_reinit: `${scope}.system.ui.archive_reinit`,
    archive_archiver: `${scope}.system.ui.archive_archiver`,
    archive_download: `${scope}.system.ui.archive_download`,
    taille: `${scope}.system.ui.taille`,
    fees_type: `${scope}.system.ui.fees_type`,
    table_h_echeancier_nom: `${scope}.system.ui.table_h_echeancier_nom`,
    table_h_echeancier_date: `${scope}.system.ui.table_h_echeancier_date`,
    table_h_montant: `${scope}.system.ui.table_h_montant`,
    table_h_echeancier_type: `${scope}.system.ui.table_h_echeancier_type`,
    table_h_profil: `${scope}.system.ui.table_h_profil`,
    table_h_group: `${scope}.system.ui.table_h_group`,
    table_h_scolarite: `${scope}.system.ui.table_h_scolarite`,
    books_loan_requested: `${scope}.system.ui.books_loan_requested`,
    biblio_quantitedispo: `${scope}.system.ui.biblio_quantitedispo`,
    en_stock: `${scope}.system.ui.en_stock`,
    donateur: `${scope}.system.ui.donateur`,
    mes_livres_empruntes: `${scope}.system.ui.mes_livres_empruntes`,
    bibliotheque: `${scope}.system.ui.bibliotheque`,
    disponible: `${scope}.system.ui.disponible`,
    indisponible: `${scope}.system.ui.indisponible`,
    description: `${scope}.system.ui.description`,
    prix_monnaie: `${scope}.system.ui.prix_monnaie`,
    biblio_catlivre: `${scope}.system.ui.biblio_catlivre`,
    biblio_edit_book: `${scope}.system.ui.biblio_edit_book`,
    emprunter: `${scope}.system.ui.emprunter`,
    doc_file: `${scope}.system.ui.doc_file`,
    doc_file_open: `${scope}.system.ui.doc_file_open`,
    jour: `${scope}.system.ui.jour`,
    doc_folder_todelete: `${scope}.system.ui.doc_folder_todelete`,
    doc_file_todelete: `${scope}.system.ui.doc_file_todelete`,
    doc_upload_file: `${scope}.system.ui.doc_upload_file`,
    doc_folder_delete: `${scope}.system.ui.doc_folder_delete`,
    gestion_compte: `${scope}.system.ui.gestion_compte`,
    doc_file_delete: `${scope}.system.ui.doc_file_delete`,
    doc_folder: `${scope}.system.ui.doc_folder`,
    doc_edit_folder: `${scope}.system.ui.doc_edit_folder`,
    doc_add_folder: `${scope}.system.ui.doc_add_folder`,
    doc_del_folder: `${scope}.system.ui.doc_del_folder`,
    doc_update_folder: `${scope}.system.ui.doc_update_folder`,
    doc_del_file: `${scope}.system.ui.doc_del_file`,
    doc_add_file: `${scope}.system.ui.doc_add_file`,
    doc_folder_concerns: `${scope}.system.ui.doc_folder_concerns`,
    doc_folder_concerns_empty: `${scope}.system.ui.doc_folder_concerns_empty`,
    doc_rename_folder: `${scope}.system.ui.doc_rename_folder`,
    doc_rename_file: `${scope}.system.ui.doc_rename_file`,
    doc_rename_folder_help: `${scope}.system.ui.doc_rename_folder_help`,
    doc_rename_file_help: `${scope}.system.ui.doc_rename_file_help`,
    doc_rename_submit: `${scope}.system.ui.doc_rename_submit`,
    doc_rename_current: `${scope}.system.ui.doc_rename_current`,
    doc_ctx_open: `${scope}.system.ui.doc_ctx_open`,
    doc_ctx_rename: `${scope}.system.ui.doc_ctx_rename`,
    doc_ctx_delete: `${scope}.system.ui.doc_ctx_delete`,
    doc_ctx_new_folder: `${scope}.system.ui.doc_ctx_new_folder`,
    doc_ctx_upload: `${scope}.system.ui.doc_ctx_upload`,
    doc_ctx_blank_hint: `${scope}.system.ui.doc_ctx_blank_hint`,
    doc_realtime_refresh: `${scope}.system.ui.doc_realtime_refresh`,
    doc_realtime_refresh_by: `${scope}.system.ui.doc_realtime_refresh_by`,
    doc_realtime_live: `${scope}.system.ui.doc_realtime_live`,
    doc_realtime_offline: `${scope}.system.ui.doc_realtime_offline`,
    doc_sort_label: `${scope}.system.ui.doc_sort_label`,
    doc_sort_name_asc: `${scope}.system.ui.doc_sort_name_asc`,
    doc_sort_name_desc: `${scope}.system.ui.doc_sort_name_desc`,
    doc_sort_type: `${scope}.system.ui.doc_sort_type`,
    doc_sort_owner: `${scope}.system.ui.doc_sort_owner`,
    doc_filter_label: `${scope}.system.ui.doc_filter_label`,
    doc_filter_search_folder: `${scope}.system.ui.doc_filter_search_folder`,
    doc_filter_search_file: `${scope}.system.ui.doc_filter_search_file`,
    doc_filter_all_types: `${scope}.system.ui.doc_filter_all_types`,
    doc_filter_clear: `${scope}.system.ui.doc_filter_clear`,
    doc_filter_no_result: `${scope}.system.ui.doc_filter_no_result`,
    ims_day_sieste_true: `${scope}.system.ui.ims_day_sieste_true`,
    ims_day_sieste_false: `${scope}.system.ui.ims_day_sieste_false`,
    ims_day_sieste_debut: `${scope}.system.ui.ims_day_sieste_debut`,
    ims_day_sieste_fin: `${scope}.system.ui.ims_day_sieste_fin`,
    ims_day_bowel: `${scope}.system.ui.ims_day_bowel`,
    ims_day_bowel_many: `${scope}.system.ui.ims_day_bowel`,
    ims_day_week_ims: `${scope}.system.ui.ims_day_week_ims`,
    ims_day_how_ate: `${scope}.system.ui.ims_day_how_ate`,
    book_loan_valid: `${scope}.system.ui.book_loan_valid`,
    book_loan_retour_valid: `${scope}.system.ui.book_loan_retour_valid`,
    emprunteur: `${scope}.system.ui.emprunteur`,
    biblio_livre_delete: `${scope}.system.ui.biblio_livre_delete`,
    emprunt_delete_title: `${scope}.system.ui.emprunt_delete_title`,
    biblio_livre_todelete: `${scope}.system.ui.biblio_livre_todelete`,
    emprunter_book: `${scope}.system.ui.emprunter_book`,
    emprunt_sentence_sujet: `${scope}.system.ui.emprunt_sentence_sujet`,
    biblio_livre: `${scope}.system.ui.biblio_livre`,
    biblio_recommend: `${scope}.system.ui.biblio_recommend`,
    biblio_recommend_title: `${scope}.system.ui.biblio_recommend_title`,
    biblio_recommend_classrooms: `${scope}.system.ui.biblio_recommend_classrooms`,
    biblio_recommend_children: `${scope}.system.ui.biblio_recommend_children`,
    biblio_recommend_message: `${scope}.system.ui.biblio_recommend_message`,
    biblio_recommend_message_default: `${scope}.system.ui.biblio_recommend_message_default`,
    biblio_recommend_note: `${scope}.system.ui.biblio_recommend_note`,
    biblio_recommend_no_classroom: `${scope}.system.ui.biblio_recommend_no_classroom`,
    biblio_recommend_no_children: `${scope}.system.ui.biblio_recommend_no_children`,
    biblio_recommend_remove: `${scope}.system.ui.biblio_recommend_remove`,
    biblio_recommend_selected_count: `${scope}.system.ui.biblio_recommend_selected_count`,
    biblio_recommend_send: `${scope}.system.ui.biblio_recommend_send`,
    sb_recommandation_sent: `${scope}.system.ui.sb_recommandation_sent`,
    none: `${scope}.system.ui.none`,
    selection_delete: `${scope}.system.ui.selection_delete`,
    selection_to_delete: `${scope}.system.ui.selection_to_delete`,
    delete_selection_confirm: `${scope}.system.ui.delete_selection_confirm`,
    retry_action: `${scope}.system.ui.retry_action`,
    school_year_load_error: `${scope}.system.ui.school_year_load_error`,
    error_boundary_title: `${scope}.system.ui.error_boundary_title`,
    error_boundary_reload: `${scope}.system.ui.error_boundary_reload`,
    error_boundary_message: `${scope}.system.ui.error_boundary_message`,
    notifications_empty: `${scope}.system.ui.notifications_empty`,
    page_not_found_title: `${scope}.system.ui.page_not_found_title`,
    page_not_found_message: `${scope}.system.ui.page_not_found_message`,
    page_not_found_back: `${scope}.system.ui.page_not_found_back`,
    ws_connecting: `${scope}.system.ui.ws_connecting`,
    ws_disconnected: `${scope}.system.ui.ws_disconnected`,
    selection_edition: `${scope}.system.ui.selection_edition`,
    add_item: `${scope}.system.ui.add_item`,
    add_children: `${scope}.system.ui.add_children`,
    generate_financial_schedule: `${scope}.system.ui.generate_financial_schedule`,
    scolarite_typepaiement: `${scope}.system.ui.scolarite_typepaiement`,
    scolarite_echeancier: `${scope}.system.ui.scolarite_echeancier`,
    scolarite_echeancier_enfant: `${scope}.system.ui.scolarite_echeancier_enfant`,
    fraisoneshot_enfant: `${scope}.system.ui.fraisoneshot_enfant`,
    matchingfraisoneshot_enfant: `${scope}.system.ui.matchingfraisoneshot_enfant`,
    groups: `${scope}.system.ui.groups`,
    the_group: `${scope}.system.ui.the_group`,
    load_children: `${scope}.system.ui.load_children`,
    paiementantidate: `${scope}.system.ui.paiementantidate`,
    groupsenfants: `${scope}.system.ui.groupsenfants`,


    initiator: `${scope}.system.ui.initiator`,
    tooltip_generate_account: `${scope}.system.ui.tooltip_generate_account`,
    tooltip_activate_account: `${scope}.system.ui.tooltip_activate_account`,
    tooltip_suspended_account: `${scope}.system.ui.tooltip_suspended_account`,
    tooltip_deleted_account: `${scope}.system.ui.tooltip_deleted_account`,
    all_label: `${scope}.system.ui.all_label`,
    teacher: `${scope}.system.ui.teacher`,
    demandeur: `${scope}.system.ui.demandeur`,
    all_label_rdv: `${scope}.system.ui.all_label_rdv`,
    show_all_label_rdv: `${scope}.system.ui.show_all_label_rdv`,
    mes_notifications: `${scope}.system.ui.mes_notifications`,
    paiement_mode_numero_placeholder: `${scope}.system.ui.paiement_mode_numero_placeholder`,
    paiement_mode_numero: `${scope}.system.ui.paiement_mode_numero`,
    paiement_mode_date: `${scope}.system.ui.paiement_mode_date`,
    paiement_cheque: `${scope}.system.ui.paiement_cheque`,
    paiement_espece: `${scope}.system.ui.paiement_espece`,
    paiement_virement: `${scope}.system.ui.paiement_virement`,
    paiement_deleted: `${scope}.system.ui.paiement_deleted`,
    paiement_antidate_op: `${scope}.system.ui.paiement_antidate_op`,
    nom_op: `${scope}.system.ui.nom_op`,
    paiement_mode: `${scope}.system.ui.paiement_mode`,
    paiement_by: `${scope}.system.ui.paiement_by`,
    paiement_date: `${scope}.system.ui.paiement_date`,
    survey_list: `${scope}.system.ui.survey_list`,
    add_survey_list: `${scope}.system.ui.add_survey_list`,
    open_survey_list: `${scope}.system.ui.open_survey_list`,
    close_survey_list: `${scope}.system.ui.close_survey_list`,
    gestion_compte_parent: `${scope}.system.ui.gestion_compte_parent`,
    gestion_compte_equipe: `${scope}.system.ui.gestion_compte_equipe`,
    accountetat_ok: `${scope}.system.ui.accountetat_ok`,
    accountetat_locked: `${scope}.system.ui.accountetat_locked`,
    accountetat_pending_validation: `${scope}.system.ui.accountetat_pending_validation`,
    accountetat_suspended: `${scope}.system.ui.accountetat_suspended`,
    generer_compte_question: `${scope}.system.ui.generer_compte_question`,
    suspendre_compte_question: `${scope}.system.ui.suspendre_compte_question`,
    activer_compte_question: `${scope}.system.ui.activer_compte_question`,
    supprimer_compte_question: `${scope}.system.ui.supprimer_compte_question`,
    generer_compte: `${scope}.system.ui.generer_compte`,
    fermer_compte: `${scope}.system.ui.fermer_compte`,
    activer_compte: `${scope}.system.ui.activer_compte`,
    supprimer_compte: `${scope}.system.ui.supprimer_compte`,
    account_ok: `${scope}.system.ui.account_ok`,
    account_locked: `${scope}.system.ui.account_locked`,
    account_pending_validation: `${scope}.system.ui.account_pending_validation`,
    account_suspended: `${scope}.system.ui.account_suspended`,
    libelle_libelle: `${scope}.system.ui.libelle_libelle`,
    libelle_title: `${scope}.system.ui.libelle_title`,
    close_this: `${scope}.system.ui.close_this`,
    close_sondage: `${scope}.system.ui.close_sondage`,
    sondage_parents_concernes: `${scope}.system.ui.sondage_parents_concernes`,
    sondage_parents_concernes_hint: `${scope}.system.ui.sondage_parents_concernes_hint`,
    sondage_parent_sexe_filter: `${scope}.system.ui.sondage_parent_sexe_filter`,
    sondage_parent_sexe_mother: `${scope}.system.ui.sondage_parent_sexe_mother`,
    sondage_parent_sexe_father: `${scope}.system.ui.sondage_parent_sexe_father`,
    sondage_no_parent_available: `${scope}.system.ui.sondage_no_parent_available`,
    sondage_search_parent_child: `${scope}.system.ui.sondage_search_parent_child`,
    notif_create: `${scope}.system.ui.notif_create`,
    notif_update: `${scope}.system.ui.notif_update`,
    notif_delete: `${scope}.system.ui.notif_delete`,
    notif_update_action: `${scope}.system.ui.notif_update_action`,
    notif_read: `${scope}.system.ui.notif_read`,
    // Notification categories (Skote inbox left panel) -- en/fr values already exist,
    // these short keys expose the same ids for direct lookup.
    notif_cat_all: `${scope}.system.ui.notif_cat_all`,
    notif_cat_favoris: `${scope}.system.ui.notif_cat_favoris`,
    notif_cat_rdv: `${scope}.system.ui.notif_cat_rdv`,
    notif_cat_enfants: `${scope}.system.ui.notif_cat_enfants`,
    notif_cat_message_center: `${scope}.system.ui.notif_cat_message_center`,
    notif_cat_documents: `${scope}.system.ui.notif_cat_documents`,
    notif_cat_alertmessage: `${scope}.system.ui.notif_cat_alertmessage`,
    notif_cat_imsday: `${scope}.system.ui.notif_cat_imsday`,
    notif_cat_facture: `${scope}.system.ui.notif_cat_facture`,
    notif_cat_proforma: `${scope}.system.ui.notif_cat_proforma`,
    notif_cat_miniclubs: `${scope}.system.ui.notif_cat_miniclubs`,
    notif_cat_sondage: `${scope}.system.ui.notif_cat_sondage`,
    notif_cat_commerceproduit: `${scope}.system.ui.notif_cat_commerceproduit`,
    notif_cat_commercevente: `${scope}.system.ui.notif_cat_commercevente`,
    notif_cat_livremprunt: `${scope}.system.ui.notif_cat_livremprunt`,
    notif_cat_autre: `${scope}.system.ui.notif_cat_autre`,
    notif_select_all: `${scope}.system.ui.notif_select_all`,
    notif_favorite_add: `${scope}.system.ui.notif_favorite_add`,
    notif_favorite_remove: `${scope}.system.ui.notif_favorite_remove`,
    notif_filter_all: `${scope}.system.ui.notif_filter_all`,
    notif_filter_unread: `${scope}.system.ui.notif_filter_unread`,
    notif_filter_read: `${scope}.system.ui.notif_filter_read`,
    notif_sort_newest: `${scope}.system.ui.notif_sort_newest`,
    notif_sort_oldest: `${scope}.system.ui.notif_sort_oldest`,
    header_nom: `${scope}.system.ui.header_nom`,
    header_code: `${scope}.system.ui.header_code`,
    header_quantite: `${scope}.system.ui.header_quantite`,
    send_to: `${scope}.system.ui.send_to`,
    rdv_list: `${scope}.system.ui.rdv_list`,
    oui: `${scope}.system.ui.oui`,
    non: `${scope}.system.ui.non`,
    period: `${scope}.system.ui.period`,
    return_to_list: `${scope}.system.ui.return_to_list`,
    ims_menu_cantine_obs: `${scope}.system.ui.ims_menu_cantine_obs`,
    ims_nap_time: `${scope}.system.ui.ims_nap_time`,
    ims_menu_obs_very_well: `${scope}.system.ui.ims_menu_obs_very_well`,
    ims_menu_obs_easily: `${scope}.system.ui.ims_menu_obs_easily`,
    ims_menu_obs_good: `${scope}.system.ui.ims_menu_obs_good`,
    ims_menu_obs_not_good: `${scope}.system.ui.ims_menu_obs_not_good`,
    ims_menu_obs_not_at_all: `${scope}.system.ui.ims_menu_obs_not_at_all`,
    ims_menu_day: `${scope}.system.ui.ims_menu_day`,
    note: `${scope}.system.ui.note`,
    ims_plat_entree: `${scope}.system.ui.ims_plat_entree`,
    ims_plat_plat: `${scope}.system.ui.ims_plat_plat`,
    ims_plat_dessert: `${scope}.system.ui.ims_plat_dessert`,
    rdv_read_void: `${scope}.system.ui.rdv_read_void`,
    rdv_realtime_refresh: `${scope}.system.ui.rdv_realtime_refresh`,
    rdv_realtime_refresh_by: `${scope}.system.ui.rdv_realtime_refresh_by`,
    rdv_realtime_deleted: `${scope}.system.ui.rdv_realtime_deleted`,
    rdv_realtime_deleted_by: `${scope}.system.ui.rdv_realtime_deleted_by`,
    rdv_realtime_edit_deleted: `${scope}.system.ui.rdv_realtime_edit_deleted`,
    rdv_realtime_edit_deleted_by: `${scope}.system.ui.rdv_realtime_edit_deleted_by`,
    obs_parent: `${scope}.system.ui.obs_parent`,
    child_stuff: `${scope}.system.ui.child_stuff`,
    obs_gen: `${scope}.system.ui.obs_gen`,
    day: `${scope}.system.ui.day`,
    ims_day_title: `${scope}.system.ui.ims_day_title`,
    times_number: `${scope}.system.ui.times_number`,
    child: `${scope}.system.ui.child`,
    horaire: `${scope}.system.ui.horaire`,
    start_day: `${scope}.system.ui.start_day`,
    end_day: `${scope}.system.ui.end_day`,
    hour: `${scope}.system.ui.hour`,
    start_hour: `${scope}.system.ui.start_hour`,
    end_hour: `${scope}.system.ui.end_hour`,
    save_form_crud_btn: `${scope}.system.ui.save_form_crud_btn`,
    edit: `${scope}.system.ui.edit`,
    delete_in_table: `${scope}.system.ui.delete_in_table`,
    back_action_stepper: `${scope}.system.ui.back_action_stepper`,
    next_action_stepper: `${scope}.system.ui.next_action_stepper`,
    import_action: `${scope}.system.ui.import_action`,
    la_valeur: `${scope}.system.ui.la_valeur`,
    must_be_uniq: `${scope}.system.ui.must_be_uniq`,
    sb_add_success: `${scope}.system.ui.snackbar.message.sb_add_success`,
    sb_edit_success: `${scope}.system.ui.snackbar.message.sb_edit_success`,
    sb_delete_success: `${scope}.system.ui.snackbar.message.sb_delete_success`,
    sb_success: `${scope}.system.ui.snackbar.message.sb_success`,
    sb_error: `${scope}.system.ui.snackbar.message.sb_error`,
    sb_action_error: `${scope}.system.ui.snackbar.message.sb_action_error`,
    required_field: `${scope}.system.ui.snackbar.message.required_field`,
    sb_selection_empty: `${scope}.system.ui.snackbar.message.sb_selection_empty`,
    sb_selection_only_suspended_account: `${scope}.system.ui.snackbar.message.sb_selection_only_suspended_account`,
    sb_employee_exist: `${scope}.system.ui.snackbar.message.sb_employee_exist`,
    sb_only_suspended_to_active: `${scope}.system.ui.snackbar.message.sb_only_suspended_to_active`,
    sb_filesize_limit: `${scope}.system.ui.snackbar.message.sb_filesize_limit`,
    sb_not_enough_book_in_store: `${scope}.system.ui.snackbar.message.sb_not_enough_book_in_store`,
    sb_parent_already_exist: `${scope}.system.ui.snackbar.message.sb_parent_already_exist`,
    sb_err_conflict: `${scope}.system.ui.snackbar.message.sb_err_conflict`,
    sb_error_400: `${scope}.system.ui.snackbar.message.sb_error_400`,
    sb_data_exist: `${scope}.system.ui.snackbar.message.sb_data_exist`,
    sb_data_not_found: `${scope}.system.ui.snackbar.message.sb_data_not_found`,
    sb_person_email_exist: `${scope}.system.ui.snackbar.message.sb_person_email_exist`,
    sb_err_bad_request: `${scope}.system.ui.snackbar.message.sb_err_bad_request`,
    enum_admin: `${scope}.system.ui.enum.role.enum_admin`,
    enum_teacher: `${scope}.system.ui.enum.role.enum_teacher`,
    enum_support: `${scope}.system.ui.enum.role.enum_support`,

    //FORM CONNEXTION
    title_form_login: `${scope}.page.user.login.form.title_form_login`,
    mail_number_form_login: `${scope}.page.user.login.form.input.mail_number_form_login`,
    password_form_login: `${scope}.page.user.login.form.input.password_form_login`,
    remember_form_login: `${scope}.page.user.login.form.input.remember_form_login`,
    forgot_password_form_login: `${scope}.page.user.login.form.input.forgot_password_form_login`,
    connection_form_login: `${scope}.page.user.login.form.button.connection_form_login`,
    logout_form_app: `${scope}.page.user.login.form.button.logout_form_app`,
    login_username_required: `${scope}.page.user.login.form.error.login_username_required`,
    login_password_required: `${scope}.page.user.login.form.error.login_password_required`,
    login_error_network: `${scope}.page.user.login.form.error.login_error_network`,
    login_error_auth: `${scope}.page.user.login.form.error.login_error_auth`,
    session_expired_message: `${scope}.page.user.login.form.error.session_expired_message`,
    // RESET PASSWORD FORM
    title_form_reset: `${scope}.page.user.forgot_password.form.title_form_reset`,
    email_form_reset: `${scope}.page.user.forgot_password.form.input.email_form_reset`,
    reset_password_form_reset: `${scope}.page.user.forgot_password.form.button.reset_password_form_reset`,

    search: {
        id: `${scope}.search`,
        defaultMessage: 'Search',
    },
    contacts: {
        id: `${scope}.contacts`,
        defaultMessage: 'Contacts',
    },
    add_contacts: {
        id: `${scope}.add_contacts`,
        defaultMessage: 'Add New Contact',
    },
    all: {
        id: `${scope}.all`,
        defaultMessage: 'All',
    },
    favorites: {
        id: `${scope}.favorites`,
        defaultMessage: 'Favorites',
    },
    block: {
        id: `${scope}.block`,
        defaultMessage: 'Block Contact',
    },
    delete: {
        id: `${scope}.delete`,
        defaultMessage: 'Delete Contact',
    },
    phone: {
        id: `${scope}.phone`,
        defaultMessage: 'Phone',
    },
    secondary_phone: {
        id: `${scope}.secondary_phone`,
        defaultMessage: 'Secondary Phone',
    },
    personal_email: {
        id: `${scope}.personal_email`,
        defaultMessage: 'Personal Email',
    },
    company_email: {
        id: `${scope}.company_email`,
        defaultMessage: 'Company Email',
    },
    address: {
        id: `${scope}.address`,
        defaultMessage: 'Address',
    },
    website: {
        id: `${scope}.website`,
        defaultMessage: 'Website',
    },
    add_new: {
        id: `${scope}.add_new`,
        defaultMessage: 'Add New Item',
    },
    upload: {
        id: `${scope}.upload`,
        defaultMessage: 'UPLOAD AVATAR',
    },
    name: {
        id: `${scope}.name`,
        defaultMessage: 'Name',
    },
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Title',
    },
    submit: {
        id: `${scope}.submit`,
        defaultMessage: 'Submit',
    },
    reset: {
        id: `${scope}.reset`,
        defaultMessage: 'Reset',
    }

}

export default messages;